import { Outlet } from "react-router-dom";

const Debate = () => {
  return <Outlet />;
};
export default Debate;